import { defineStyle, defineStyleConfig, SystemStyleObject } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';

const getGradient = (position: 'left' | 'right', variant: 'contained' | 'line') => {
  const style: SystemStyleObject = {
    content: `""`,
    position: 'absolute',
    width: '8',
    top: '0',
    bottom: '0',
    bgGradient: `linear(${position === 'left' ? 'to-r' : 'to-l'}, ${
      variant === 'line' ? 'background/primary' : 'background/tertiary'
    }, transparent)`,
  };

  if (position === 'left') {
    style.right = '-8px';
  } else {
    style.left = '-8px';
  }

  return style;
};

const baseStyle = defineStyle(
  ({ variant }): SystemStyleObject => ({
    containedTab: {
      _first: {
        _focusVisible: {
          boxShadow: 'inset 0 2px var(--colors-purple-50), inset 0 0 0 3px var(--colors-purple-70)',
        },
        boxShadow: 'none',
      },
      _focusVisible: {
        boxShadow: 'inset 0 2px var(--colors-purple-50), inset 0 0 0 3px var(--colors-purple-70)',
      },
      _hover: {
        backgroundColor: 'background/active',
      },
      _disabled: {
        backgroundColor: 'neutral.90',
        color: 'neutral.70',
        cursor: 'not-allowed',
      },
      _selected: {
        '+ [role="tab"]': {
          boxShadow: 'none',
        },
        _first: {
          boxShadow: 'inset 0 2px var(--colors-purple-50)',
        },
        _hover: {
          backgroundColor: 'neutral.100',
        },
        backgroundColor: 'neutral.100',
        borderRight: 0,
        boxShadow: 'inset 0 2px var(--colors-purple-50)',
        div: {
          color: 'purple.50',
        },
      },
      backgroundColor: 'neutral.93',
      boxShadow: 'inset 1px 0 0 var(--colors-neutral-80)',
      color: 'neutral.40',
      alignContent: 'center',
      paddingX: '16',
      paddingY: '12',
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
    lineTab: {
      _hover: {
        backgroundColor: 'background/secondary',
      },
      _active: {
        backgroundColor: 'neutral.93',
      },
      _disabled: {
        background: 'transparent',
        color: 'neutral.70',
        cursor: 'not-allowed',
      },
      _focusVisible: {
        boxShadow: 'inset 0 -2px var(--colors-purple-50), inset 0 0 0 3px var(--colors-purple-70)',
      },
      _selected: {
        _hover: {
          backgroundColor: 'transparent',
        },
        boxShadow: 'inset 0 -2px var(--colors-purple-50)',
        color: 'purple.50',
      },
      alignItems: 'center',
      color: 'neutral.50',
      display: 'flex',
      gap: '8',
      justifyContent: 'flex-start',
      paddingX: '16',
      paddingY: '12',
      textStyle: 'comp/tabs/line',
      whiteSpace: 'nowrap',
    },
    tablist: {
      borderBottom: variant === 'line' ? '1px solid' : undefined,
      borderBottomColor: variant === 'line' ? 'separator.primary' : undefined,
      maxWidth: '100%',
      overflowY: 'hidden',
      overflowX: 'scroll',
      scrollbarWidth: 'none',
      '::-webkit-scrollbar': {
        width: 0,
      },
    },
    tabpanel: {
      _focusVisible: {
        boxShadow: 'none',
      },
    },
    arrowButton: {
      width: variant === 'line' ? '48' : rem(68),
      height: variant === 'line' ? '48' : rem(68),
      borderRadius: 0,
      backgroundColor: variant === 'line' ? 'background/primary' : 'background/tertiary',
      flexShrink: 0,
      color: 'icon/primary',
      paddingY: '12',
      paddingX: '16',
      position: 'absolute',
      top: '0',
    },
    arrowButtonGradient: ((position: 'left' | 'right') => getGradient(position, variant)) as any,
  }),
);

const TabsTheme = defineStyleConfig({
  baseStyle,
});

export default TabsTheme;
